import GetBuyers from './GetBuyers.component';

export default GetBuyers;
